export default "__VITE_ASSET__CmFon711__"